<template>
  <div id="container">
    <!--  通过 iframe 嵌入前端定位组件，此处没有隐藏定位组件，使用了定位组件的在定位中视觉特效  -->
    <iframe
      id="geoPage"
      width="100%"
      height="0"
      frameborder="0"
      scrolling="no"
      src="https://apis.map.qq.com/tools/geolocation?key=LW5BZ-N6VCX-IAW4Z-7K4GF-LB63S-STF6H&referer=myapp&effect=circle"
    ></iframe>
    <!-- 接收到位置信息后 通过 iframe 嵌入位置标注组件 -->
    <iframe
      id="markPage"
      width="100%"
      height="100%"
      frameborder="0"
      scrolling="no"
      src=""
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "map",
  data() {
    return {
      markerLayer: null, // MultiMarker
      key: "P6BBZ-L25RQ-YGQ5W-GF6XH-CHGEH-FAFMW",
    };
  },
  methods: {
    // 将百度地图经纬度转换为腾讯/高德地图经纬度
    bMapTransQQMap(lng, lat) {
      let x_pi = (3.14159265358979324 * 3000.0) / 180.0;
      let x = lng - 0.0065;
      let y = lat - 0.006;
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta);
      let lats = z * Math.sin(theta);

      return {
        lng: lngs,
        lat: lats,
      };
    },
  },
  mounted() {
    var coordinate = this.bMapTransQQMap(
      this.$route.query.longitude,
      this.$route.query.latitude
    );
    console.log(coordinate.lng, coordinate.lat, 12345);
    var address = this.$route.query.address;
    var agencyName = this.$route.query.agencyName;
    var key = "LW5BZ-N6VCX-IAW4Z-7K4GF-LB63S-STF6H";
    var isMapInit = false;
    //监听定位组件的message事件
    window.addEventListener(
      "message",
      function (event) {
        var loc = event.data; // 接收位置信息
        console.log("location", loc);
        loc.lng = coordinate.lng;
        loc.lat = coordinate.lat;
        if (loc && loc.module == "geolocation") {
          //定位成功,防止其他应用也会向该页面post信息，需判断module是否为'geolocation'
          var markUrl =
            "https://apis.map.qq.com/tools/poimarker" +
            "?marker=coord:" +
            loc.lat +
            "," +
            loc.lng +
            ";title:" +
            agencyName +
            ";addr:" +
            address +
            "&key=" +
            key +
            "&referer=myapp";
          //给位置展示组件赋值
          console.log(markUrl, 11111111);
          document.getElementById("markPage").src = markUrl;
        } else {
          //定位组件在定位失败后，也会触发message, event.data为null
          console.log("定位失败");
        }

        /* 另一个使用方式
            if (!isMapInit && !loc) { //首次定位成功，创建地图
                isMapInit = true;
                createMap(event.data);
            } else if (event.data) { //地图已经创建，再收到新的位置信息后更新地图中心点
                updateMapCenter(event.data);
            }
            */
      },
      false
    );
    //为防止定位组件在message事件监听前已经触发定位成功事件，在此处显示请求一次位置信息
    document
      .getElementById("geoPage")
      .contentWindow.postMessage("getLocation", "*");

    //设置6s超时，防止定位组件长时间获取位置信息未响应
    setTimeout(function () {
      if (!loc) {
        //主动与前端定位组件通信（可选），获取粗糙的IP定位结果
        document
          .getElementById("geoPage")
          .contentWindow.postMessage("getLocation.robust", "*");
      }
    }, 6000); //6s为推荐值，业务调用方可根据自己的需求设置改时间，不建议太短
  },
};
</script>

<style scoped>
#container {
  width: 100%;
  height: 100%;
}
#geoPage{
  position: absolute;
}
</style>
